import Vue from "vue";
Vue.component("dataTable", require("./dataTable").default);
